import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  );
};

export default LoadingSpinner;